import { useContext, useEffect, useState } from "react";
import { Text, Link, SkeletonItem } from "@fluentui/react-components";
import APIHelper from "../../../services/api-helper";
import TodosCard from "./to-dos-card";
import { APIInterceptor } from "../../../core/interceptor/api-interceptor";
import { StateContext } from "../../../core/store/state-context";
import { IToDoProps } from "../../../hooks/types";
import TodosCardSkeleton from "./to-dos-skeleton";
import TodosNoCard from "./to-dos-nocard";
import { _blank, componentConstants, errorLoggingConstants } from "../../../utility/app-constants";
import { LogError } from "../../../utility/app-utilities";
import { Open16Regular } from "@fluentui/react-icons";
import moment from "moment";
import ComponentErrorScreen from "../error-screens/component-error-screen";

/**
 * To dos main component to display all to dos and skeleton while loading
 * @returns 
 */
export default function Todos() {
  const [{ context }] = useContext(StateContext);
  const [todo, setTodo] = useState<IToDoProps[]>([]);
  const [axios] = APIInterceptor("todo component");
  const apiHelper = new APIHelper(axios, context);
  const [loading, setLoading] = useState<Boolean>(true);
  const [isTodoAPIFailed, setIsTodoAPIFailed] = useState<boolean>(false);

  /* Get To do items from API Helper */
  useEffect(() => {
    apiHelper
      .getTodo()
      .then(async (response) => {
        if (response.data.todo.length > 0 && response.data.todo[0].hasOwnProperty("title")) {
          let uniqueLocStorageTodoTitles: string[] = JSON.parse(localStorage.getItem("todoTitles")!);
          let todoUniqueTitles: string[] = [];
          response.data.todo.forEach((key: IToDoProps) => {
            todoUniqueTitles.push(key.title);
            Object.assign(key, { "counterBadge": true });
            if (uniqueLocStorageTodoTitles !== null && uniqueLocStorageTodoTitles !== undefined && uniqueLocStorageTodoTitles.includes(key.title))
              Object.assign(key, { "counterBadge": false });
          });
          localStorage.setItem("todoTitles", JSON.stringify(todoUniqueTitles));
        }
        setTodo(response.data.todo);
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false);
        setIsTodoAPIFailed(true);
        const errorObject = {
          component: errorLoggingConstants.todoComponentFile,
          method: errorLoggingConstants.useEffect,
          message: error as string,
          operation: errorLoggingConstants.todosAPI,
          params: {}
        };
        LogError(errorObject);
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={isTodoAPIFailed ? "todo-container error-screen" : "todo-container"} data-testid="to-dos-container">
      <div className={isTodoAPIFailed ? "todo-header error-screen" : "todo-header"}>
        {
          !loading ? (
            <><Text className="text" data-testid="to-dos-title">  {componentConstants.todosTitle}  </Text><div className="view-link">
              <Link href={componentConstants.linkHrefUrl} className="link-text" target={_blank}>
                {componentConstants.viewAllLinkText}
                <Open16Regular className="todo-view-link-img" />
              </Link>
            </div></>
          ) : (
            <SkeletonItem appearance="translucent" className="todo-header-skeleton" shape="rectangle" size={16} />
          )
        }
      </div>
      <div className="todo-card-container">

        {
          loading ? (isTodoAPIFailed ? <ComponentErrorScreen /> :
            [0, 1, 2].map((val, i) => (
              <TodosCardSkeleton key={i} />
            ))
          ) :
            (isTodoAPIFailed ? <ComponentErrorScreen /> : todo.length <= 0 ? (
              <TodosNoCard />
            ) : (
              todo.map((data, key) => (
                key <= 2 && (
                  <TodosCard key={key}
                    title={data.title}
                    link={data.link}
                    deadlineDate={moment(data.deadlineDate).format('MMM D, YYYY')}
                    urgentDeadline={data.urgentDeadline}
                    counterBadge={data.counterBadge}
                  />)
              )))
            )
        }
      </div>
    </div>
  );
}
